import React from 'react';
import { TextField, Box } from '@mui/material';

export default function CustomTextField({ labelText, handleChange, labelName, textValue }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <label htmlFor="custom-input" style={{ fontWeight: 500 }}>
                {labelText}
            </label>
            <TextField
                id="custom-input"
                name={labelName}
                size='small'
                variant="outlined"
                placeholder={`Enter ${labelText}`}
                value={textValue}
                onChange={handleChange} />
        </Box>
    );
}
